import { createRoot } from 'react-dom/client';
import { createContext, StrictMode } from 'react';
import App from './App';
import PLAYBOOKS from "../../data/playbooks.json"

let counters = await fetch("/counters").then((response=>response.json()))
let container = document.getElementById("app")!;
let root = createRoot(container);
root.render(
  <StrictMode>
    <App initialCounters={counters} descriptions={PLAYBOOKS}/>
  </StrictMode>
);
